<template>
  <div>
    <span>{{ time }}</span>
  </div>
</template>

<script>
  export default {
    props: {
      time: {
        type: String,
        default: ''
      }
    }
  };
</script>
